export default __webpack_public_path__ + "static/media/tweet2.ce7c7327.png";